import type { ReactElement } from 'react';

const STATUS_OPTIONS = {
  REJECTED: 'rejected'
} as const;

export const getWithdrawalSummary = (
  status: string
): ReactElement | undefined => {
  if (status === STATUS_OPTIONS.REJECTED) {
    return <p>Sorry, we could not process this withdrawal request.</p>;
  }
};
